// extracted by mini-css-extract-plugin
export default {"container":"TemplatesTable_container__LcWtf","navLink":"TemplatesTable_navLink__XwQuO"};